<template>
	<BaseCmsPage v-slot="{page}" :fetch-slug-segments="2">
		<AuthLoginRegisterLayout>
			<template #col1>
				<h1>{{ page?.seo_h1 }}</h1>
				
				
				<!-- <div class="form-subtitle"><BaseCmsLabel code="email_login" /></div> -->

				<BaseAuthSignupForm class="form-signup form-animated-label" v-slot="{fields, errors, apiErrors, status, contentType, loading}">
					<div class="form-subtitle" v-if="!status?.success" ><BaseCmsLabel code="social_login" /></div>
					<AuthSocialLogin v-if="!status?.success" />

					<BaseAuthConfirmSignup v-if="contentType == 'confirmSignup'" v-slot="{status}" redirect="auth_login" :redirect-timeout="3000">
						<BaseCmsLabel :code="status.label_name" />
					</BaseAuthConfirmSignup>
					<template v-else>
						<template v-if="!status?.success">
							<div class="signup-form-fields">
								<template v-if="apiErrors?.length">
									<div class="global-error" v-for="apiError in apiErrors" :key="apiError">{{ apiError.field }}: {{ apiError.error }}</div>
								</template>
								<template v-if="Object.keys(errors)?.length">
									<BaseCmsLabel tag="div" class="global-error" code="form_validation_error" data-scroll-to-error />
								</template>
								<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel, isTouched, value}">
									<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}, {'success': !errorMessage && isTouched && value}]" v-interpolation>
										<!--
										<span v-if="item.name == 'accept_terms'">
											<AuthTermsModal />
										</span>
										-->
										<BaseFormInput :id="'signup-'+item.name" />
										<BaseCmsLabel v-if="item.name == 'accept_terms'" v-interpolation tag="label" :for="'signup-'+item.name" :code="item.name+'_signup'" />
										<BaseCmsLabel v-else tag="label" :for="'signup-'+item.name" :code="item.name" />
										<span class="error" v-show="errorMessage" v-html="errorMessage" />
									</p>
								</BaseFormField>
								<button class="confirm-registration" type="submit" :class="{'loading': loading}"><UiLoader size="small" v-if="loading" /><BaseCmsLabel code="confirm_signup" /></button>
							</div>
						</template>
						<div v-else>
							<BaseCmsLabel tag="div" class="global-success" :code="status.data.label_name" />
						</div>
					</template>
				</BaseAuthSignupForm>
			</template>
			<template #col2>
				<div class="checkin-have-account">
					<BaseCmsLabel code="have_account_already" tag="h2" />
					<div class="auth-buttons">
						<BaseAuthUser v-slot="{urls}">
							<NuxtLink :to="urls.auth_login" class="btn">
								<BaseCmsLabel code="login" />
							</NuxtLink>
							<NuxtLink :to="urls.auth_forgotten_password" class="btn btn-white btn-forgotten-password" data-auth_login="forgotten_password" data-siteform_response="show_hide" data-siteform_response_hide="-1">
								<BaseCmsLabel code="forgotten_password_userbox" />
							</NuxtLink>
						</BaseAuthUser>
					</div>
				</div>
				
				<div v-if="page?.content" class="cms-content register-content" v-html="page?.content" v-interpolation></div>
				<AuthLoginRegisterBenefits mode="register" />
			</template>
		</AuthLoginRegisterLayout>
	</BaseCmsPage>
</template>

<script setup>
	const {getAppUrl} = useApiRoutes();
</script>

<style scoped lang="less">
	h1{
		font-size: 25px; padding: 0 0 15px;
		@media (max-width: @m){font-size: 18px; padding-bottom: 10px;}		
	}
	.form-subtitle{font-weight: bold; font-size: 12px; color: var(--darkGray);}
	:deep(.btns){padding: 10px 0 12px;}
	.signup-form-fields{display: flex; flex-wrap: wrap; justify-content: space-between;}
	.field, .global-error{width: 100%;}
	.field-first_name, .field-last_name{
		width: calc(~"50% - 5px");
		@media (max-width: @m){width: 100%;}	
	}
	.confirm-registration{
		margin-top: 7px;
		@media (max-width: @m){width: auto; padding-inline: 24px; margin-top: 8px;}	
	}
	.field-newsletter{
		margin-top: 7px;
		@media (max-width: @m){margin-top: 10px;}	
	}
	.field-accept_terms{
		.error{padding-left: 30px;}
	}
	input[type=checkbox] + label{
		@media (max-width: @m){
			font-size: 12px;
			&:before{top: -1px;}	
		}
	}

	//col2
	.checkin-have-account{
		padding-top: 72px;
		@media (max-width: @t){padding-top: 24px;}
		@media (max-width: @m){
			padding-top: 0;
			h2{padding-bottom: 16px;}	
		}
	}
	:deep(h2){
		font-size: 25px; padding-bottom: 12px;
		@media (max-width: @m){font-size: 18px; padding-bottom: 7px;}	
	}
	.auth-buttons{
		display: flex; gap: 16px; padding: 4px 0 56px;
		.btn{flex: 1 1 auto;}
		@media (max-width: @t){gap: 4px; padding-bottom: 35px;}
		@media (max-width: @m){gap: 10px; padding-bottom: 35px; flex-flow: column;}
	}
	.btn-forgotten-password{
		&:after{display: none;}
	}
	.register-content{font-size: 14px; line-height: 23px;}
</style>
